// removed by extract-text-webpack-plugin
module.exports = {"portal-notification-sidenav":"portal-notification-sidenav___2Pb-b","portal-notification-sidenav__content":"portal-notification-sidenav__content___2-6ln"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/components/notification-sidenav/notification-sidenav.module.scss
// module id = 398
// module chunks = 8